module.exports = __webpack_public_path__ + "static/media/nest2.0394eeb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/nest2.jpg
// module id = 97
// module chunks = 0